export function sendErrorToDataLayer (error) {
  const dataLayer = window.dataLayer
  if (!dataLayer) return
  const eventInfo = {
    event: 'warning',
    eventСategory: 'Warning',
    eventAction: 'Something went wrong',
    eventLabel: error
  }
  dataLayer.push(eventInfo)
  return eventInfo
}

export function sendSuccessfulPurchase (insuranceType, totalPrice, policyNumber, productName, customDemensions) {
  const dataLayer = window.dataLayer
  if (!dataLayer) return
  dataLayer.push({
    event: 'purchase',
    eventCategory: 'Ecommerce',
    eventAction: 'Purchase',
    eventLabel: insuranceType,
    eventValue: Number(totalPrice) * 0.275,
    ecommerce:
    {
      purchase: {
        actionField: {
          id: policyNumber,
          revenue: Number(totalPrice) * 0.275
        },
        products: [
          {
            name: productName,
            id: policyNumber,
            brand: 'QIC',
            category: insuranceType,
            price: Number(totalPrice) * 0.275,
            quantity: 1,
            customDimension2: customDemensions && customDemensions.carBrand,
            customDimension3: customDemensions && customDemensions.carModel,
            customDimension4: customDemensions && customDemensions.carYear,
            customDimension5: customDemensions && customDemensions.countryVisit,
            customDimension6: customDemensions && customDemensions.numberOfPeople,
            customDimension7: customDemensions && customDemensions.countryResidence,
            customDimension8: customDemensions && customDemensions.motoBrand,
            customDimension9: customDemensions && customDemensions.motoModel,
            customDimension10: this.insuranceType === 'PAB' ? 'pab' : undefined,
            customDimension11: customDemensions && customDemensions.pabType
          }
        ]
      }
    }
  })
}

export default { sendSuccessfulPurchase }
